import { ApiUtility, IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IDropdownProps } from "../../Pages/Settings/SettingVoucherTemplate";
import { IIdNameModel } from "../ItemsService";
import { LedgerStatus } from "../LedgerService";
export interface IOrganiseData {
  orgName: string;
  id?: string;
  status?: LedgerStatus;
}
export interface ISubUnitData extends Omit<IOrganiseData, "orgName"> {
  subUnitName: string;
  orgName?: string;
  orgId?: string;
}
export interface IDepttData extends Omit<ISubUnitData, "subUnitName"> {
  depttName: string;
  depttType: Department_Type;
  subUnitId?: string;
  subUnitName?: string;
}
export interface IDesignationData
  extends Omit<IDepttData, "depttName" | "depttType"> {
  designationName: string;
  parentDesignationId?: string;
  depttId?: string;
  depttName?: string;
}
export interface IEmpData extends Omit<IDesignationData, "designationName"> {
  empName: string;
  empCode: string;
  email: string;
  fatherName?: string;
  createLoginCredential: boolean;
  seniorEmpId?: string;
  designationId?: string;
  designationName?: string;
}

// Organisation's request models
//
// interface IOrgRequestModel {
//   orgName: string;
//   id?: string;
// }
export interface ISubUnitRequestModel {
  subUnitName: string;
  orgId: string;
  id?: string;
}
export interface IDepttRequestModel {
  depttName: string;
  orgId: string;
  subUnitId: string;
  depttType: Department_Type;
  id?: string;
}
export interface IDesignationRequestModel {
  designationName: string;
  orgId: string;
  subUnitId: string;
  depttId: string;
  id?: string;
  parentDesignationId?: string;
}
export interface IEmpRequestModel {
  empName: string;
  empCode: string;
  fatherName: string;
  email: string;
  createLoginCredential: boolean;
  seniorEmpId: string;
  orgId: string;
  subUnitId: string;
  depttId: string;
  designationId: string;
  id?: string;
}
export enum Department_Type {
  Administration,
  Account,
  Purchase,
  Sales,
  HR,
  Production,
  Dispatch,
  Store,
  RnD,
  Laboratory,
  //TODO: more department options will be here
  Other = 15,
}

export const DepartmentTypeList: IDropdownProps<Department_Type>[] = [
  {
    key: Department_Type.Administration,
    value: Department_Type.Administration,
    label: "Administration",
  },
  {
    key: Department_Type.Account,
    value: Department_Type.Account,
    label: "Account",
  },
  {
    key: Department_Type.Purchase,
    value: Department_Type.Purchase,
    label: "Purchase",
  },
  {
    key: Department_Type.Sales,
    value: Department_Type.Sales,
    label: "Sales",
  },
  {
    key: Department_Type.HR,
    value: Department_Type.HR,
    label: "Human Resource",
  },
  {
    key: Department_Type.Production,
    value: Department_Type.Production,
    label: "Production",
  },
  {
    key: Department_Type.Dispatch,
    value: Department_Type.Dispatch,
    label: "Dispatch",
  },
  {
    key: Department_Type.Store,
    value: Department_Type.Store,
    label: "Store",
  },
  {
    key: Department_Type.RnD,
    value: Department_Type.RnD,
    label: "Research & Development",
  },
  {
    key: Department_Type.Laboratory,
    value: Department_Type.Laboratory,
    label: "Laboratory",
  },
  {
    key: Department_Type.Other,
    value: Department_Type.Other,
    label: "Others",
  },
];

class OrganisationService {
  route = "V1/API";

  // ----- Organisation Services(Api) -----
  //Get List API
  getOrganisationsList = (
    companyId: string,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.getResult<IOrganiseData[]>(
      `${this.route}/Acc_Organisations/${companyId}/GetList`,
      {
        search,
        sortCol,
        sortDir,
        status,
      }
    );
  //Get API
  getOrganisation = (companyId: string, orgId: string) =>
    ApiUtility.getResult<IOrganiseData>(
      `${this.route}/Acc_Organisations/${companyId}/${orgId}`
    );
  //Post API
  postOrganisation = (
    companyId: string | undefined,
    params: any,
    orgId?: string
  ) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Organisations/${companyId}/${orgId ? orgId : ""}`,
      params
    );
  //Delete API
  deleteOrganisation = (companyId: string, orgId: string) =>
    ApiUtility.delete<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Organisations/${companyId}/${orgId}`
    );

  // ----- Sub Unit Services(Api) -----
  //Get List API
  getSubUnitsList = (
    companyId: string,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.getResult<ISubUnitData[]>(
      `${this.route}/Acc_SubUnits/${companyId}/GetList`,
      {
        search,
        sortCol,
        sortDir,
        status,
      }
    );
  //Get API
  getSubUnit = (companyId: string, subUnitId: string) =>
    ApiUtility.getResult<ISubUnitData>(
      `${this.route}/Acc_SubUnits/${companyId}/${subUnitId}`
    );
  //Post API
  postSubUnit = (
    companyId: string | undefined,
    params: any,
    subUnitId?: string
  ) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_SubUnits/${companyId}/${subUnitId ? subUnitId : ""}`,
      params
    );
  //Delete API
  deleteSubUnit = (companyId: string, subUnitId: string) =>
    ApiUtility.delete<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_SubUnits/${companyId}/${subUnitId}`
    );

  // ----- Department Services(Api) -----
  //Get List API
  getDepttList = (
    companyId: string,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.getResult<IDepttData[]>(
      `${this.route}/Acc_Departments/${companyId}/GetList`,
      {
        search,
        sortCol,
        sortDir,
        status,
      }
    );
  //Get API
  getDepartment = (companyId: string, depttId: string) =>
    ApiUtility.getResult<IDepttRequestModel>(
      `${this.route}/Acc_Departments/${companyId}/${depttId}`
    );
  //Post API
  postDepartment = (companyId: string | undefined, params: any, id?: string) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Departments/${companyId}/${id ? id : ""}`,
      params
    );
  //Delete Api
  deleteDepartment = (companyId: string, depttId: string) =>
    ApiUtility.delete<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Departments/${companyId}/${depttId}`
    );

  // ----- Designation Services(Api) -----
  //Get List API
  getDesignationsList = (
    companyId: string,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.getResult<IDesignationData[]>(
      `${this.route}/Acc_Designations/${companyId}/GetList`,
      {
        search,
        sortCol,
        sortDir,
        status,
      }
    );
  //Get API
  getDesignation = (companyId: string, designationId: string) =>
    ApiUtility.getResult<IDesignationRequestModel>(
      `${this.route}/Acc_Designations/${companyId}/${designationId}`
    );
  //Post API
  postDesignation = (
    companyId: string | undefined,
    params: any,
    designationId?: string
  ) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Designations/${companyId}/${
        designationId ? designationId : ""
      }`,
      params
    );
  //Delete API
  deleteDesignation = (companyId: string, designationId: string) =>
    ApiUtility.delete<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Designations/${companyId}/${designationId}`
    );

  // ----- Employee Services(Api) -----
  //Get List API
  getEmployeesList = (
    companyId: string,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.getResult<IEmpData[]>(
      `${this.route}/Acc_Employees/${companyId}/GetList`,
      {
        search,
        sortCol,
        sortDir,
        status,
      }
    );
  //Get API
  getEmployee = (companyId: string, empId: string) =>
    ApiUtility.getResult<IEmpRequestModel>(
      `${this.route}/Acc_Employees/${companyId}/${empId}`
    );
  //Post API
  postEmployee = (companyId: string | undefined, params: any, empId?: string) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Employees/${companyId}/${empId ? empId : ""}`,
      params
    );
  //Delete API
  deleteEmployee = (companyId: string, empId: string) =>
    ApiUtility.delete<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_Employees/${companyId}/${empId}`
    );
}
export default new OrganisationService();
